import {
  Hero,
  Offerings,
  WhyChooseUs,
  Stats,
  TrustSection,
  CTABanner,
} from "@/components/home/Hero"
import { ClienteleSection } from "@/components/home/ClienteleSection"
import { PageShell } from "@/components/layout/PageShell"
import { usePageMeta } from "@/hooks/usePageMeta"

export function Home() {
  usePageMeta({
    title: "Maxitherm Works | Energy and Environment Solutions",
    description:
      "Maxitherm Works provides sustainable industrial solutions for energy, environment, process heating, cooling, and water treatment as an IBR Approved Firm - Class I and Thermax Channel Associate.",
    pathname: "/",
  })

  return (
    <PageShell>
      <Hero />
      <Offerings />
      <WhyChooseUs />
      <Stats />
      <ClienteleSection />
      <TrustSection />
      <CTABanner />
    </PageShell>
  )
}
